// eslint-disable-next-line import/prefer-default-export
export const ESUBMODULEROUTES = {
  INCOMES: "/incomes",
  EXPENSES: "/expenses/upload-expenses",
  REPORTS: "/reports",
  CLIENTS: "/clients",
};
